import { EnvironmentInjector, Inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable, of } from 'rxjs';
import { AuthService } from '../auth.service';
import { localizeRoute } from '../../../shared/utilities/localizeRoutes';


export const DEMO_ROLE_CLAIM: string = "demo_single_property"

@Injectable({
    providedIn: 'root'
})
export class DemoGuardService {
    constructor(private authService: AuthService, private _router: Router, @Inject(EnvironmentInjector) private envInjector: EnvironmentInjector) { }

    public canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
        this.authService.isLoggedIn().subscribe((isLoggedIn: boolean) => {
            if (!isLoggedIn) {
                return true;
            } else {
                var userInfo = this.authService.getCurrentUser();//.subscribe( x=> userInfo = x);
                const demoRoleClaim = userInfo?.profile[DEMO_ROLE_CLAIM] as string
                //Create user
                if (demoRoleClaim) {
                    this._router.navigate([localizeRoute(`properties/${demoRoleClaim}`, this.envInjector)], { queryParamsHandling: 'preserve' })
                    return false;
                }

                else {
                    return true;
                }
            }
        });
        return of(true);
    }
}


